export default {
  LEARN_MORE: '8ee252c4-5a00-4888-a7ba-251f46d451b8',
};
